import store from '@/redux/store';
import types from '@/redux/type';
import { PageTypeEnum } from './enum';

export const logout: () => void = () => {
	store.dispatch({
		type: types.CHANGE_LOGIN_STATUS,
		data: false,
	});
	store.dispatch({
		type: types.CHANGE_USERINFO,
		data: null,
	});
	store.dispatch({
		type: types.CHANGE_CURRENT_PAGE_TYPE,
		data: PageTypeEnum.SYSTEM_PAGE,
	});
};
